<template>
<div>
    <b-container fluid>
        <b-row>
            <b-col :xl="8">
                <card>
                    <TimetableTable @selectItem="onSelectItem" @newItem="onNewItem"></TimetableTable>
                </card>
            </b-col>
            <b-col :xl="4">
                <InfoCard v-if="action == ''"></InfoCard>
                
                <card v-if="action == 'new'">
                    <CardHeader :title="$t('item.new')"/>
                    <TimetableViewForm :item="item" action="new" @saved="onCreated"/>
                </card>

                <card v-if="action == 'item' && item">
                    <CardHeader :title="item ? item.id: ''" type="item" />
                    <tabs :value="currentTabTitle">
                        <tab-pane title="tab-1" key="tab-1" v-if="$UIPrivilege('content/timetables', 'departures')">
                            <b-icon id="tab-departures" slot="title" icon="clock" scale='1.1'></b-icon> 
                            <b-popover target="tab-departures" triggers="hover" placement="top">
                            {{$t("timetable.tooltips.departures")}}
                            </b-popover>
                            <TimetableViewDepartures :item="item" count="100" />
                        </tab-pane>

                        <tab-pane title="tab-2" key="tab-2" v-if="$UIPrivilege('content/timetables', 'info')">
                            <b-icon id="info" slot="title" icon="info-square" scale='1.1'></b-icon> 
                            <b-popover target="info" triggers="hover" placement="top">
                            {{$t("timetable.tooltips.info")}}
                            </b-popover>
                            <TimetableViewInfo :item="item" />
                        </tab-pane>

                        <tab-pane title="tab-3" key="tab-3" v-if="$UIPrivilege('content/timetables', 'stops')">
                            <b-icon id="stops" slot="title" icon="list-ol" scale='1.1'></b-icon> 
                            <b-popover target="stops" triggers="hover" placement="top">
                            {{$t("timetable.tooltips.stops")}}
                            </b-popover>
                            <TimetableViewStops :item="item" />
                        </tab-pane>
                      
                        <tab-pane title="tab-4" key="tab-4" v-if="$UIPrivilege('content/timetables', 'fullscreen')">
                            <b-icon id="fullscreen" slot="title" icon="link" scale='1.1'></b-icon> 
                            <b-popover target="fullscreen" triggers="hover" placement="top">
                            {{$t("timetable.tooltips.fullscreen")}}
                            </b-popover>
                            <TimetableViewLinks :item="item" />
                        </tab-pane>

                        <tab-pane title="tab-5" key="tab-5" v-if="$UIPrivilege('content/timetables', 'settings')">
                            <b-icon id="settings" slot="title" icon="gear" scale='1.1'></b-icon> 
                            <b-popover target="settings" triggers="hover" placement="top">
                            {{$t("timetable.tooltips.settings")}}
                            </b-popover>
                            <TimetableViewSettings :item="item" />
                        </tab-pane>

                        <tab-pane title="tab-6" key="tab-6">
                            <b-icon id="basicinfo" slot="title" icon="card-list" scale='1.1'></b-icon>
                            <b-popover target="basicinfo" triggers="hover" placement="top">
                            {{$t("timetable.tooltips.basicinfo")}}
                            </b-popover> 
                            <TimetableViewForm :item="item" action="item" />
                        </tab-pane>
                    </tabs>
                </card>
            </b-col>
            </b-row>
    </b-container>
    <b-toaster name="timetableToaster" class="b-toaster-top-right"></b-toaster>
</div>
</template>

<script>
import CardHeader from '@/components/Misc/CardHeader'
import TimetableTable from '@/components/Content/Timetables/TimetableTable'
import TimetableViewForm from '@/components/Content/Timetables/TimetableViewForm'
import TimetableViewStops from '@/components/Content/Timetables/TimetableViewStops'
import TimetableViewDepartures from '@/components/Content/Timetables/TimetableViewDepartures'
import TimetableViewInfo from '@/components/Content/Timetables/TimetableViewInfo' 
import TimetableViewLinks from '@/components/Content/Timetables/TimetableViewLinks'
import TimetableViewSettings from '@/components/Content/Timetables/TimetableViewSettings'  


export default { 
    components: {
        CardHeader,
        TimetableTable, 
        TimetableViewForm, 
        TimetableViewStops,
        TimetableViewDepartures, 
        TimetableViewInfo, 
       /* TimetableSettings, */
        TimetableViewLinks,
        TimetableViewSettings
    },
    data() {
        return {
            item:{},
            tabIndex: 2,
            action: "",
            currentTabTitle: "tab-1"
        
        }
    },
    mounted() {
        if(this.$route.query.id) {
            this.filter = this.$route.query.id
        }
    },
    created() {
        this.$root.$on('removedTimetable', () =>{
            this.onRemoved();
        })
    },
    methods: {
        onNewItem() {
            this.item = null;
            this.action = "new"
        },
        onSelectItem(item) {
            this.item = item;
            this.action = "item"
            this.currentTabTitle = "tab-1"
        },
        onCreated(item) {
            this.item = item;
            this.action = "item";
            this.currentTabTitle = "tab-6";
        },
        onRemoved(){
            this.item = null;
            this.action = "";
        }
       
    }

}
</script>